import { Fragment, useCallback, useState } from 'react';

import MoveToButton from '../../components/attendance/moveToButton/MoveToButton.component';
import DrawerComponent from '../../components/common/Drawer.component';
import { Stack } from '@mui/material';
import { Form } from '../../components/form/Form';
import ConfirmButton from '../../components/actions/ConfirmButton';
import ConfirmDialog from '../../components/common/Confirm.component';
import Alert from '../../components/common/Alert.component';
import { useSelector } from 'react-redux';
import { fetchAPI } from '../../api/request';

const MoveToTemplate = ({
  conf,
  label,
  api,
  body,
  onSuccess = () => {},
  disabled = false,
}) => {
  const { schema, defaultValues, fields } = conf;
  const { jwt } = useSelector((state) => state.login);
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState(null);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const handleOpen = useCallback((data) => {
    setOpen(true);
    setValues(data);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const onSumit = useCallback(() => {
    setSuccess(false);
    setError(null);
    fetchAPI(api, {}, '', { ...values, ...body }, jwt)
      .then(() => {
        setSuccess(true);
        handleClose();
        onSuccess(values);
      })
      .catch((error) => setError(error));
  }, [values, handleClose, jwt, api, body, onSuccess]);

  return (
    <Fragment>
      {error && <Alert severity='error'>{'An error has occurred'}</Alert>}

      {success && <Alert severity='success'>{'Success'}</Alert>}

      <DrawerComponent
        button={<MoveToButton label={'Move To'} disabled={disabled} />}
        defaultOpen={open}
        disabled={disabled}
      >
        <Stack spacing={4}>
          {label}
          <Form
            schema={schema}
            defaultValues={defaultValues}
            fields={fields}
            onSubmit={handleOpen}
          >
            <ConfirmButton />
          </Form>
        </Stack>

        <ConfirmDialog
          open={open}
          onClose={handleClose}
          title='Are you sure you want to proceed?'
          description='This action is permanently. You cannot undo this action.'
          cancelAction={handleClose}
          confirmAction={onSumit}
          label={'Confirm'}
          color='info'
        />
      </DrawerComponent>
    </Fragment>
  );
};

export default MoveToTemplate;
